__turbopack_context__.v({
  "leftIcon": "Pill-module__LlmYOW__leftIcon",
  "pill": "Pill-module__LlmYOW__pill",
  "vehicleSpec": "Pill-module__LlmYOW__vehicleSpec",
});
